import React from 'react';
import Seo from '../components/Seo/Seo';
import './Imprint.css'; // Import the CSS file

const Imprint = () => {
  return (
    <section className="imprint-section">
      <Seo
        title="Impressum – Nexite IT"
        description="Impressum der Nexite IT – rechtliche Angaben, Kontaktinformationen, Urheberrecht, Haftungshinweise und Informationen gemäß § 5 TMG."
        path="/impressum"
      />

      <div className="imprint-container">
        <h1>Impressum</h1>

        <div className="imprint-content">
          <h2>Vertreten durch</h2>
          <p>
            Khashayar Alavi<br />
            Auf dem Schnorrenberg 6,<br />
            50354 Hürth<br />
            Deutschland
          </p>

          <h2>Kontakt</h2>
          <p>
            <strong>Telefon:</strong> +49 178 8622282<br />
            <strong>E-Mail:</strong> info[at]nexite-it.com
          </p>

          <h2>USt-Befreiung</h2>
            <p>
              Umsatzsteuerbefreiung gemäß § 19 UStG (Kleinunternehmerregelung):<br />
              Kein Ausweis von Umsatzsteuer.
            </p>

          <h2>EU-Streitbeilegung</h2>
          <p>
            Die Europäische Kommission stellt eine Plattform für die Online-Streitbeilegung (ODR) bereit:<br />
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
              https://ec.europa.eu/consumers/odr
            </a>.
          </p>
          <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>

          <h2>Haftungsausschluss</h2>
          <p>
            <strong>Inhaltliche Verantwortung:</strong><br />
            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </p>
          <p>
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
          </p>

          <h2>Haftung für Links</h2>
          <p>
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
          </p>
          <p>
            Die Verlinkung fremder Seiten oder Inhalte auf unserer Website bedeutet nicht, dass wir uns die verlinkten Inhalte und dort eventuell geäußerten Ansichten und Meinungen zu eigen machen. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
          </p>
          <p>
            Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
          </p>

          <h2>Urheberrecht</h2>
          <p>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
          <p>
            Downloads und Kopien dieser Seite sind nur für den privaten, nicht den kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet.
          </p>
          <p>
            Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
          </p>

          <h2>Streitbeilegung</h2>
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>

          <h2>Quellenangaben</h2>
          <p>
            Bis auf wenige Ausnahmen wurden alle auf dieser Website dargestellten Bilder & Videos von Nexite IT-Mitarbeitern erstellt.
          </p>

          <h2>Verantwortlicher für den Inhalt nach § 55 Abs. 2 RStV:</h2>
          <p>Khashayar Alavi</p>
        </div>
      </div>
    </section>
  );
};

export default Imprint;